<template>
  <div id="box">
    <div class="historyTag">
      <historyTag :historyArr="historyArr"></historyTag>
    </div>

    <el-alert
      type="warning"
      :closable="false"
      show-icon
      title="买家确认收货后约 20 分钟调汇付支付确认。失败常见原因是微信资金未解冻（发货未同步到微信，或未走微信官方确认收货）。系统会自动重试；也可手动立即重试。"
      style="margin-bottom: 12px"
    />

    <div class="topBox flex">
      <div class="topLeft flex" style="align-items: center; flex-wrap: wrap">
        <div class="flex" style="align-items: center; margin-right: 12px; margin-bottom: 4px">
          <span style="white-space: nowrap; margin-right: 8px">订单号：</span>
          <el-input v-model="query.orderNo" clearable placeholder="模糊" style="width: 180px" @keyup.enter.native="searchFn" />
        </div>
        <div class="flex" style="align-items: center; margin-right: 12px; margin-bottom: 4px">
          <span style="white-space: nowrap; margin-right: 8px">订单ID：</span>
          <el-input v-model="query.orderIdStr" clearable placeholder="精确" style="width: 120px" @keyup.enter.native="searchFn" />
        </div>
        <div class="flex" style="align-items: center; margin-right: 12px; margin-bottom: 4px">
          <span style="white-space: nowrap; margin-right: 8px">状态：</span>
          <el-select v-model="query.status" style="width: 150px">
            <el-option label="未完成" :value="-1" />
            <el-option label="等待首次分账" :value="0" />
            <el-option label="分账失败重试中" :value="1" />
            <el-option label="已分账成功" :value="2" />
          </el-select>
        </div>
        <el-button type="success" size="small" @click="searchFn">搜索</el-button>
        <el-button size="small" @click="resetFn">重置</el-button>
      </div>
    </div>

    <div class="table-scroll-wrap">
      <el-table :data="tableData" border style="width: 100%; margin-top: 12px" v-loading="loading">
        <el-table-column prop="orderNo" label="订单号" min-width="170" show-overflow-tooltip />
        <el-table-column prop="orderId" label="订单ID" width="88" align="center" />
        <el-table-column prop="productTitle" label="商品" min-width="160" show-overflow-tooltip />
        <el-table-column prop="orderStatusLabel" label="订单状态" width="110" align="center" />
        <el-table-column label="确认收货时间" width="168" align="center">
          <template slot-scope="scope">{{ formatTime(scope.row.confirmTime) }}</template>
        </el-table-column>
        <el-table-column prop="payAmt" label="实付" width="80" align="right" />
        <el-table-column prop="sellerAmount" label="卖家" width="80" align="right" />
        <el-table-column prop="platformAmount" label="平台" width="80" align="right" />
        <el-table-column prop="statusLabel" label="分账状态" width="120" align="center" />
        <el-table-column prop="huifuConfirmRetryCount" label="重试次数" width="88" align="center" />
        <el-table-column label="下次尝试" width="168" align="center">
          <template slot-scope="scope">{{ formatTime(scope.row.huifuConfirmAfterAt) }}</template>
        </el-table-column>
        <el-table-column prop="lastError" label="失败原因" min-width="220" show-overflow-tooltip />
        <el-table-column label="操作" width="120" align="center" fixed="right">
          <template slot-scope="scope">
            <el-button
              v-if="scope.row.status === 0 || scope.row.status === 1"
              type="text"
              size="small"
              :loading="retryingId === scope.row.id"
              @click="retryNow(scope.row)"
            >立即重试</el-button>
            <span v-else>-</span>
          </template>
        </el-table-column>
      </el-table>
    </div>

    <list-pagination
      :total="tableTotal"
      :current-page.sync="currentPage"
      :page-size.sync="pageSize"
      @page-change="changePage"
      @size-change="handlePageSizeChange"
    />
  </div>
</template>

<script>
import { returnTime } from "@/util/utils";

export default {
  name: "HuifuDelayConfirmList",
  data() {
    return {
      historyArr: ["客诉处理", "汇付延迟分账列表"],
      loading: false,
      tableData: [],
      tableTotal: 0,
      currentPage: 1,
      pageSize: 20,
      query: {
        orderNo: "",
        orderIdStr: "",
        status: -1
      },
      retryingId: null
    };
  },
  mounted() {
    this.fetchList(1);
  },
  methods: {
    formatTime(t) {
      if (!t) return "-";
      try {
        return returnTime(t, "-", "s");
      } catch (e) {
        return String(t);
      }
    },
    buildPayload() {
      const payload = {
        page: this.currentPage,
        size: this.pageSize,
        status: this.query.status,
        orderNo: this.query.orderNo || undefined
      };
      if (this.query.orderIdStr) {
        payload.orderId = Number(this.query.orderIdStr);
      }
      return payload;
    },
    fetchList(page) {
      if (page) this.currentPage = page;
      this.loading = true;
      this.$https(this.$api.api.mgmtHuifuDelayConfirmList, this.buildPayload(), "POST")
        .then((res) => {
          const body = (res && res.data) || {};
          if (body.code === 200) {
            this.tableData = body.data || [];
            this.tableTotal = body.size != null ? body.size : 0;
          } else {
            this.tableData = [];
            this.tableTotal = 0;
            this.$message.error(body.msg || "查询失败");
          }
        })
        .catch(() => {
          this.tableData = [];
          this.tableTotal = 0;
          this.$message.error("网络异常");
        })
        .finally(() => {
          this.loading = false;
        });
    },
    searchFn() {
      this.fetchList(1);
    },
    resetFn() {
      this.query = { orderNo: "", orderIdStr: "", status: -1 };
      this.fetchList(1);
    },
    changePage(p) {
      this.fetchList(p);
    },
    handlePageSizeChange() {
      this.fetchList(1);
    },
    retryNow(row) {
      if (!row || !row.id) return;
      this.$confirm("立即向汇付发起支付确认？若微信资金仍冻结会继续失败并自动排期。", "手动重试分账", {
        confirmButtonText: "立即重试",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          this.retryingId = row.id;
          return this.$https(
            this.$api.api.mgmtHuifuDelayConfirmRetry,
            { id: row.id },
            "POST"
          );
        })
        .then((res) => {
          if (!res) return;
          const body = res.data || {};
          if (body.code === 200) {
            this.$message.success(body.msg || "分账成功");
            this.fetchList(this.currentPage);
          } else {
            this.$message.error(body.msg || "重试失败");
            this.fetchList(this.currentPage);
          }
        })
        .catch(() => {})
        .finally(() => {
          this.retryingId = null;
        });
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/pages/huifuDelayConfirm/index.vue